import axios from '../../../axios';
import IProfileDashboard from '../types/IProfileDashboard';

const url = 'wsreporting/api/profile-dashboard';

export const getMyProfileDashboards = () => axios.get(`${url}/my-profile-dashboards`);

export const getAllProfileDashboardsByWorkspaceId = () =>
  axios.get(`${url}/all-profile-dashboards`);

export const tagDashboard = (profileDashboard: IProfileDashboard) =>
  axios.post(`${url}/tag-dashboard`, profileDashboard);
